import { GET_NEXT_ITEMS } from '../redux/actions/randomItems';
import store from '../redux/store';

export const getNextItems = (
    searchTerms = {},
    filterTerms = {},
    setSearchTerm,
    university_id,
    queryTerms = {},
    setFilterTerm,
    groupUniversities,
    setUniGroup,
    setSearchUniversityGroupBubble
) => {
    const setFilter = (item, groupUniversities) => {
        let filterFound = false;
        if (setFilterTerm && groupUniversities) {
            for (let key in groupUniversities) {
                let university = groupUniversities[key];
                if (university.name === item) {
                    let filterTerm = {
                        type: 'fixed',
                        key: 'group_universities',
                        id: university.id,
                        name: university.name,
                    };
                    store.dispatch(setSearchUniversityGroupBubble(university.name));
                    store.dispatch(setFilterTerm(filterTerm));
                    store.dispatch(setUniGroup([university.id]));
                    filterFound = true;
                    break;
                }
            }
        }
        return filterFound;
    };

    const setItems = (university_id, searchTerms, customFilters, preparedFiltersIds) => {
        let newTerms = [];
        if (searchTerms && customFilters) {
            newTerms = searchTerms.concat(
                customFilters.filter((item) => !searchTerms.find((term) => term.toLowerCase() === item.toLowerCase()))
            );
        } else if (searchTerms) {
            newTerms = searchTerms;
        } else if (customFilters) {
            newTerms = customFilters;
        }
        store.dispatch({
            type: GET_NEXT_ITEMS,
            payload: {
                university_id: university_id,
                random: ![...searchTerms, ...customFilters].length && !preparedFiltersIds.length,
                search: newTerms,
                filterTerms: preparedFiltersIds,
                queryTerms: searchTerms,
            },
        });
    };

    if (searchTerms.length || filterTerms.customFilters.length) {
        let newTerms = [];
        if (searchTerms) {
            newTerms = searchTerms.concat(
                filterTerms.customFilters.filter(
                    (item) => !searchTerms.find((term) => term.toLowerCase() === item.toLowerCase())
                )
            );
        } else {
            newTerms = filterTerms.customFilters;
        }
        store.dispatch({
            type: GET_NEXT_ITEMS,
            payload: {
                university_id: university_id,
                search: newTerms,
                filterTerms: filterTerms.preparedFiltersIds,
                random: false,
                countryIds: filterTerms.countryIds,
            },
        });
    } else if (queryTerms.search) {
        // if there are ?search= terms in the URL, and if the search box isn't being otherwise used
        const searchTempArray = queryTerms.search.split(','); // split the ?search= terms into an array
        const searchArray = [];
        searchTempArray.map((item) => {
            item = item.trim();
            let filterGroupFound = setFilter(item, groupUniversities);
            if (!filterGroupFound) {
                store.dispatch(setSearchTerm(item));
                searchArray.push(item);
            }
        });

        setItems(university_id, searchArray, filterTerms.customFilters, filterTerms.preparedFilters);
    } else if (queryTerms.term || queryTerms.terms) {
        let searchTempArray = [];
        if (queryTerms.term) {
            const { term } = queryTerms;
            if (typeof term === 'string') {
                searchTempArray = term.split(',');
            } else {
                searchTempArray = term;
            }
        } else {
            const { terms } = queryTerms;
            if (typeof terms === 'string') {
                searchTempArray = terms.split(',');
            } else {
                searchTempArray = terms;
            }
        }
        const searchArray = [];
        searchTempArray.map((item) => {
            item = item.trim();
            let filterGroupFound = setFilter(item, groupUniversities);
            if (!filterGroupFound) {
                store.dispatch(setSearchTerm(item));
                searchArray.push(item);
            }
        });

        setItems(university_id, searchArray, filterTerms.customFilters, filterTerms.preparedFilters);
    } else if (queryTerms.searchTerms && queryTerms.searchTerms.length) {
        // for new search terms which sent as array
        const searchTerms = [];
        try {
            if (typeof queryTerms.searchTerms === 'string') {
                const item = queryTerms.searchTerms.trim();
                let filterGroupFound = setFilter(item, groupUniversities);
                if (!filterGroupFound) {
                    store.dispatch(setSearchTerm(item));
                    searchTerms.push(item);
                }
            } else {
                queryTerms.searchTerms.map((item) => {
                    item = item.trim();
                    let filterGroupFound = setFilter(item, groupUniversities);
                    if (!filterGroupFound) {
                        store.dispatch(setSearchTerm(item));
                        searchTerms.push(item);
                    }
                });
            }
        } catch (e) {
            console.log(e);
        }

        setItems(university_id, searchTerms, filterTerms.customFilters, filterTerms.preparedFiltersIds);
    } else {
        store.dispatch({
            type: GET_NEXT_ITEMS,
            payload: {
                university_id: university_id,
                isDefault: !filterTerms.preparedFilters.length,
                random: !filterTerms.preparedFilters.length,
                filterTerms: filterTerms.preparedFiltersIds,
                countryIds: filterTerms.countryIds,
                subjectIds: filterTerms.subjectIds,
                profileTypeIds: filterTerms.profileTypeIds,
            },
        });
    }
};
